
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import FormWrapper from "@/components/FormWrapper.vue";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import {mask} from "vue-the-mask";
import UyapTakipAc from "@/plugins/uyap-plugin/takip_ac/UyapTakipAc";
import {TakipAcStatusEnum} from "@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum";
import {
  isAdliyeliIlamTuru,
  isKullanimDisiIlamTuru,
  isSorgulanabilirIlamTuru,
  UyapIlamTuru
} from "@/plugins/uyap-plugin/takip_ac/IlamTuruKurallari";

/**
 * Bu formun düzenlediği Ilam alanları. Anlık görüntü/geri alma yalnızca bu alanlarla
 * sınırlı tutulur; tüm nesneyi klonlamak alacakKalemleri gibi sınıf örneklerini düz
 * nesneye çevirip Ilam.toUyapJson() zincirini bozuyordu.
 */
const DUZENLENEN_ALANLAR = [
  'ilamTuru', 'ilamTuruText', 'ilamBilgileri', 'birimId', 'birimAdi', 'adliyeId', 'il',
  'dosyaTurKod', 'dosyaTurKodText', 'dosyaYil', 'dosyaSira', 'dosyaNo',
  'kararDosyaYil', 'kararDosyaSira', 'yevmiyeYil', 'yevmiyeSira',
  'ilamliKurumAdi', 'ilamTarihi'
];

@Component({
  directives: {
    mask
  },
  components: {FormWrapper, Dates}
})
export default class UyapIlamBilgileriForm extends Mixins(ObjectInputMixin) {
  @Prop() tarafList!: any;
  @Prop() ilamSorgusuDurumu!: boolean;
  @Prop() il!: any;
  @Prop() uyapTakipAc!: UyapTakipAc;

  mdb = new MDB();
  yilMask = "####";
  // Maske UYAP'ın 6 hane sınırından geniş tutuluyor: v-mask, maskeye sığmayan MEVCUT değerleri
  // render anında kırpıp input olayı yaydığı için daraltmak sessiz veri kaybına yol açıyor.
  // Sınır bunun yerine counter ile gösteriliyor (aşıldığında kırmızıya döner).
  siraMask = "##########";
  siraMaxLength = 6;
  hakemKararSiraMask = "####################";
  hakemKararSiraMaxLength = 20;

  /** Vazgeç'te geri dönülecek başlangıç görüntüsü (yalnızca DUZENLENEN_ALANLAR). */
  private baslangicDegerleri: any = null;
  private baslangicSorguDurumu: boolean = false;
  private baslangicTakipDurumu: TakipAcStatusEnum | null = null;
  /** Tür değişiminde hangi alanların korunacağını belirlemek için önceki tür tutulur. */
  private oncekiIlamTuru: any = null;
  /** Tür değiştirilip geri dönüldüğünde veri kaybolmasın diye tür bazlı yedek. */
  private turAlanYedegi: Record<string, any> = {};

  ilamSorgulari: any = {
    dosyaTurleri: [],
    dosyaTurleriLoading: false,
    ilamTuru: "",
    yargiBirimleri: [],
    yargiBirimleriLoading: false,
    adliyeler: [],
    adliyelerLoading: false,
    mahkemeler: [],
    mahkemelerLoading: false,
    adliye: "",
    dosyaYil: "",
    dosyaSiraNo: "",
    kararYil: "",
    kararSiraNo: "",
    yevmiyeYil: "",
    yevmiyeSiraNo: "",
    dosyaTuru: "",
    yargiBirimi: "",
    il: "",
    mahkeme: null as string | null,
    ilamliKurumAdi: "",
    eslesmeDurumu: false,
    kontrolHataMesaji: "",
    kontrolYukleniyor: false
  }

  created() {
    // FormWrapper "Vazgeç"te $parent üzerinde onClose emit ediyor; değişiklikleri
    // gerçek Ilam nesnesine geri yaymak için bunu yakalıyoruz.
    this.$on('onClose', this.degisiklikleriGeriAl);
  }

  async mounted() {
    // ObjectInputMixin sığ kopya aldığı için ilamBilgileri parent ile aynı referans olur;
    // form içindeki değişikliklerin Vazgeç'e rağmen kalıcı olmaması için referansı ayırıyoruz.
    this.localValue.ilamBilgileri = {...(this.localValue.ilamBilgileri || {})};
    this.baslangicDegerleri = this.duzenlenenAlanlariAl();
    this.baslangicSorguDurumu = this.ilamSorgusuDurumu === true;
    this.baslangicTakipDurumu = this.uyapTakipAc ? this.uyapTakipAc.status : null;
    this.oncekiIlamTuru = this.localValue.ilamTuru;

    this.ilamSorgulari.dosyaSiraNo = this.localValue.dosyaSira;
    this.ilamSorgulari.dosyaYil = this.localValue.dosyaYil;
    this.ilamSorgulari.kararSiraNo = this.localValue.kararDosyaSira;
    this.ilamSorgulari.kararYil = this.localValue.kararDosyaYil;
    this.ilamSorgulari.yevmiyeSiraNo = this.localValue.yevmiyeSira;
    this.ilamSorgulari.yevmiyeYil = this.localValue.yevmiyeYil;
    this.ilamSorgulari.ilamliKurumAdi = this.localValue.ilamliKurumAdi;
    this.ilamSorgulari.eslesmeDurumu = this.ilamSorgusuDurumu;
    // İlamın kendi ili varsa o kullanılır; ilam başka ildeki bir mahkemeden olabildiği için
    // takibin ili (this.il) yalnızca yedek (DEV-2829).
    this.ilamSorgulari.il = this.localValue.il || this.il;

    if (!this.localValue.ilamTuru)
      return;

    if (!this.sorgulanabilirMi)
      return;

    await this.dosyaTurleriLoad(this.localValue.ilamTuru);
    await this.yargiBirimleriLoad(this.localValue.ilamTuru);

    if (this.localValue.ilamBilgileri?.yargiBirimi)
      this.ilamSorgulari.yargiBirimi = this.localValue.ilamBilgileri.yargiBirimi;

    if (this.adliyeliMi) {
      await this.adliyelerLoad();
      if (this.localValue.adliyeId)
        this.ilamSorgulari.adliye = this.localValue.adliyeId;
    }

    // Sadece listeleri doldurur; mevcut mahkeme seçimine dokunmaz.
    if (this.ilamSorgulari.il)
      await this.mahkemeleriYukle(this.ilamSorgulari.il);
  }

  get sorgulanabilirMi(): boolean {
    return isSorgulanabilirIlamTuru(this.localValue.ilamTuru);
  }

  get adliyeliMi(): boolean {
    return isAdliyeliIlamTuru(this.localValue.ilamTuru);
  }

  get kullanimDisiTurMu(): boolean {
    return isKullanimDisiIlamTuru(this.localValue.ilamTuru);
  }

  /** Kurum Adı + İlam Tarihi yalnızca UYAP'ta sorgulanamayan türlerde girilir. */
  get kurumBilgisiGirilecekMi(): boolean {
    return !!this.localValue.ilamTuru && !this.sorgulanabilirMi;
  }

  /**
   * UYAP'ta kullanılamayan türler listeden gizlenir; ancak mevcut kayıt o türdeyse
   * select boş görünmesin diye seçenek listede bırakılır.
   */
  get ilamTuruSecenekleri(): any[] {
    return this.mdb.ilamKurumTurleri.filter((tur: any) =>
        !isKullanimDisiIlamTuru(tur.value) || tur.value == this.localValue.ilamTuru
    );
  }

  get kararSiraMask(): string {
    return this.localValue.ilamTuru == UyapIlamTuru.HakemKarari ? this.hakemKararSiraMask : this.siraMask;
  }

  get kararSiraMaxLength(): number {
    return this.localValue.ilamTuru == UyapIlamTuru.HakemKarari ? this.hakemKararSiraMaxLength : this.siraMaxLength;
  }

  get mahkemePlaceholder(): string | null {
    if (!this.ilamSorgulari.il)
      return 'İl Seçiniz';
    if (this.adliyeliMi && (!this.ilamSorgulari.adliye || !this.ilamSorgulari.yargiBirimi))
      return 'Yargı Birimi/Adliye seçiniz.';
    return null;
  }

  /**
   * Kaydet akışı. Sorgulanabilir türlerde (Hukuk/Ceza/İdare) eşleştirme henüz
   * doğrulanmamışsa UYAP sorgusunu burada çalıştırır; sorgu başarısızsa diyalog
   * kapanmaz, hata mesajı formda kalır ve kullanıcı düzeltip tekrar dener.
   *
   * @param onValidate FormWrapper'ın alan validasyonu; geçerliyse true döner.
   */
  async kaydet(onValidate: () => boolean) {
    if (!onValidate())
      return;

    // UYAP'ta sorgulanamayan türlerde eşleştirme aranmaz; aksi halde kullanıcı
    // "İlam eşleştirme başarısız" durumundan hiçbir şekilde çıkamıyor (DEV-2700).
    if (!this.sorgulanabilirMi) {
      // Bayrağı true yapmak tek başına yetmiyor: önceki sorgudan kalan hata mesajı ve
      // QUERY_FAIL durumu satırda kalıp dosyanın seçilmesini engelliyordu (DEV-2700).
      if (this.uyapTakipAc)
        this.uyapTakipAc.ilamSorgusuHatasiniTemizle();
      this.$emit("ilamSorgu", true);
      this.$emit("onSuccess", this.localValue);
      return;
    }

    // Bayrak zaten true ise (kullanıcı Kontrol Et'e basmış ve sonrasında hiçbir
    // alanı değiştirmemiş) gereksiz UYAP isteği atılmaz.
    if (!this.ilamSorgulari.eslesmeDurumu) {
      await this.ilamBilgileriniKontrolEt();
      if (!this.ilamSorgulari.eslesmeDurumu) {
        this.$emit("ilamSorgu", false);
        return;
      }
    }

    this.$emit("ilamSorgu", true);
    this.$emit("onSuccess", this.localValue);
  }

  /** Yalnızca bu formun düzenlediği alanların sığ kopyası; ilamBilgileri ayrıca kopyalanır. */
  private duzenlenenAlanlariAl(): any {
    const anlikGoruntu: any = {};
    for (const alan of DUZENLENEN_ALANLAR) {
      const deger = this.localValue[alan];
      anlikGoruntu[alan] = (alan === 'ilamBilgileri') ? {...(deger || {})} : deger;
    }
    return anlikGoruntu;
  }

  /** Vazgeç: FormWrapper localValue'yu geri aldıktan sonra gerçek Ilam nesnesine yayıyoruz. */
  degisiklikleriGeriAl() {
    if (!this.baslangicDegerleri)
      return;
    // localValue referansı DEĞİŞTİRİLMEZ; alacakKalemleri gibi dokunmadığımız alanlar
    // gerçek sınıf örnekleri olarak kalmalı.
    Object.assign(this.localValue, this.baslangicDegerleri);
    this.localValue.ilamBilgileri = {...this.baslangicDegerleri.ilamBilgileri};
    this.input();
    // Dialog açıkken çalıştırılan sorgu parsedFile.ilamSorgusu'nu ve satır durumunu
    // doğrudan değiştiriyor; veriyi geri aldığımıza göre ikisi de eski hâline dönmeli.
    this.$emit("ilamSorgu", this.baslangicSorguDurumu);
    if (this.uyapTakipAc && this.baslangicTakipDurumu !== null)
      this.uyapTakipAc.setStatus(this.baslangicTakipDurumu);
  }

  @Watch('ilamSorgusuDurumu', {immediate: true})
  onIlamSorgusuDurumuChange(newVal: boolean) {
    this.ilamSorgulari.eslesmeDurumu = newVal;
  }

  /**
   * Sorgu sonucunu etkileyen her değişiklikte eşleştirme bayrağı düşürülür;
   * aksi halde bayat "başarılı" rozetiyle ilgisiz bir dosya için takip açılabiliyor.
   */
  private sorguSonucunuGecersizKil() {
    if (!this.sorgulanabilirMi)
      return;
    this.ilamSorgulari.eslesmeDurumu = false;
    this.ilamSorgulari.kontrolHataMesaji = "";
  }

  /**
   * Tür değişince önceki türe ait alanlar UYAP'a "hayalet" veri olarak gitmesin.
   * Kurum Adı/İlam Tarihi yalnızca sorgulanamayan türler arasında geçişte korunur;
   * bu alanlar orada aynı anlamı taşıyor.
   */
  private turAlanlariniTemizle(yeniTur: any) {
    const kurumBilgisiKorunsun =
        !isSorgulanabilirIlamTuru(this.oncekiIlamTuru) && !isSorgulanabilirIlamTuru(yeniTur);
    if (!kurumBilgisiKorunsun) {
      this.localValue.ilamliKurumAdi = "";
      this.localValue.ilamTarihi = "";
    }

    this.localValue.birimId = null;
    this.localValue.birimAdi = "";
    this.localValue.adliyeId = "";
    this.localValue.dosyaTurKod = "";
    this.localValue.dosyaTurKodText = "";
    this.localValue.dosyaYil = "";
    this.localValue.dosyaSira = "";
    this.localValue.dosyaNo = "";
    this.localValue.kararDosyaYil = "";
    this.localValue.kararDosyaSira = "";
    this.localValue.yevmiyeYil = "";
    this.localValue.yevmiyeSira = "";
    this.localValue.ilamBilgileri = {
      ...this.localValue.ilamBilgileri,
      yargiBirimi: "",
      dosyaYil: "",
      dosyaSira: ""
    };

    this.ilamSorgulari.adliye = "";
    this.ilamSorgulari.adliyeler = [];
    this.ilamSorgulari.yargiBirimi = "";
    this.ilamSorgulari.yargiBirimleri = [];
    this.ilamSorgulari.mahkeme = null;
    this.ilamSorgulari.mahkemeler = [];
    this.ilamSorgulari.dosyaTurleri = [];
  }

  async onIlamTuruChange(ilamTuruVal: any) {
    // Yanlışlıkla değiştirilen tür geri seçildiğinde veri kaybolmasın diye önceki türün
    // alanları yedekleniyor; aynı türe dönülürse yedek geri yükleniyor.
    if (this.oncekiIlamTuru !== null && this.oncekiIlamTuru !== undefined && this.oncekiIlamTuru !== '')
      this.turAlanYedegi[String(this.oncekiIlamTuru)] = this.duzenlenenAlanlariAl();

    this.turAlanlariniTemizle(ilamTuruVal);

    const yedek = this.turAlanYedegi[String(ilamTuruVal)];
    if (yedek) {
      Object.assign(this.localValue, yedek);
      this.localValue.ilamBilgileri = {...yedek.ilamBilgileri};
    }
    this.oncekiIlamTuru = ilamTuruVal;

    this.ilamSorgulari.ilamTuru = ilamTuruVal;
    this.localValue.ilamBilgileri = {...this.localValue.ilamBilgileri, ilamTuru: ilamTuruVal};
    this.localValue.ilamTuru = ilamTuruVal;
    // ilamTuruText toUyapJson ile UYAP'a gidiyor; tür ile birlikte güncellenmezse bayat kalıyor.
    this.localValue.ilamTuruText =
        this.mdb.ilamKurumTurleri.find((tur: any) => tur.value == ilamTuruVal)?.name || '';

    // Sorgulanamayan türlerde eşleştirme aranmaz, sorgulanabilir türde sıfırdan doğrulanmalı.
    this.ilamSorgulari.eslesmeDurumu = !isSorgulanabilirIlamTuru(ilamTuruVal);
    this.ilamSorgulari.kontrolHataMesaji = "";

    this.input();

    if (!isSorgulanabilirIlamTuru(ilamTuruVal))
      return;

    await this.dosyaTurleriLoad(ilamTuruVal);
    await this.yargiBirimleriLoad(ilamTuruVal);
    if (isAdliyeliIlamTuru(ilamTuruVal))
      await this.adliyelerLoad();

    // Yedekten geri yüklendiyse seçim kutularının da eski seçimleri göstermesi gerekiyor.
    if (yedek) {
      this.ilamSorgulari.adliye = this.localValue.adliyeId || "";
      this.ilamSorgulari.yargiBirimi = this.localValue.ilamBilgileri.yargiBirimi || "";
      await this.mahkemeleriYukle(this.ilamSorgulari.il);
    }
  }

  async adliyelerLoad() {
    try {
      this.ilamSorgulari.adliyelerLoading = true;
      this.ilamSorgulari.adliyeler = await this.$uyap.IldekiAdliyeler().run({il: this.ilamSorgulari.il || this.il});
    } catch (e) {
      // Adliye listesi alınamazsa formun geri kalanı çalışmaya devam etmeli.
      console.error("İldeki adliyeler yüklenemedi:", e);
      this.ilamSorgulari.adliyeler = [];
    } finally {
      this.ilamSorgulari.adliyelerLoading = false;
    }
  }

  async dosyaTurleriLoad(ilamTuruVal: number | string) {
    try {
      this.ilamSorgulari.dosyaTurleriLoading = true;
      this.ilamSorgulari.dosyaTurleri = await this.$uyap.IcraTakipIlamDosyaTuru().run({ilamTuru: ilamTuruVal});
    } catch (e) {
      console.error("İlam dosya türleri yüklenemedi:", e);
      this.ilamSorgulari.dosyaTurleri = [];
    } finally {
      this.ilamSorgulari.dosyaTurleriLoading = false;
    }
  }

  async yargiBirimleriLoad(ilamTuruVal: number | string) {
    const ilamKurumTuru = this.mdb.ilamKurumTurleri.find((tur: any) => tur.value == ilamTuruVal);
    // MDB'de yalnızca 0/1/2 için yargiTuru eşlemesi var; olmayan türde istek atılmamalı.
    if (!ilamKurumTuru || ilamKurumTuru.yargiTuru === undefined) {
      this.ilamSorgulari.yargiBirimleri = [];
      return;
    }
    try {
      this.ilamSorgulari.yargiBirimleriLoading = true;
      this.ilamSorgulari.yargiBirimleri = await this.$uyap.YargiBirimleri().run({yargiTuru: ilamKurumTuru.yargiTuru});
    } catch (e) {
      console.error("Yargı birimleri yüklenemedi:", e);
      this.ilamSorgulari.yargiBirimleri = [];
    } finally {
      this.ilamSorgulari.yargiBirimleriLoading = false;
    }
  }

  onIlamDosyaTurChange(value: number | string) {
    this.ilamSorgulari.dosyaTuru = value;
    this.localValue.dosyaTurKod = value;
    const dosyaTuru = this.ilamSorgulari.dosyaTurleri.find((dosyaTuru: any) => dosyaTuru.value == value);
    if (dosyaTuru) {
      this.localValue.dosyaTurKodText = dosyaTuru.name;
    }
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  async loadIlamAdliyedekiTumMahkemeler() {
    try {
      this.ilamSorgulari.mahkemelerLoading = true;
      this.ilamSorgulari.mahkemeler = [];
      this.ilamSorgulari.mahkemeler = await this.$uyap.AdliyedekiTumMahkemeler().run({
        adliye: this.ilamSorgulari.adliye,
        bltr2: this.ilamSorgulari.yargiBirimi
      })
    } catch (e) {
      console.error("Adliyedeki mahkemeler yüklenemedi:", e);
      this.ilamSorgulari.mahkemeler = [];
    } finally {
      this.ilamSorgulari.mahkemelerLoading = false;
    }
  }

  async loadIlamIldekiIdariBirimler() {
    try {
      this.ilamSorgulari.mahkemelerLoading = true;
      this.ilamSorgulari.mahkemeler = [];
      this.ilamSorgulari.mahkemeler = await this.$uyap.IldekiIdariBirimler().run({
        il: this.ilamSorgulari.il,
        bltr2: this.localValue.ilamBilgileri.yargiBirimi,
        isAll: true
      });
    } catch (e) {
      console.error("İldeki idari birimler yüklenemedi:", e);
      this.ilamSorgulari.mahkemeler = [];
    } finally {
      this.ilamSorgulari.mahkemelerLoading = false;
    }
  }

  /**
   * Mahkeme listesini doldurur. Mevcut seçimi ASLA silmez; bu yüzden mounted() içinden
   * de güvenle çağrılabilir (eskiden buradaki temizlik yüzünden dialog her açıldığında
   * seçili mahkeme kayboluyordu - DEV-2709).
   */
  async mahkemeleriYukle(il: any) {
    if (!il)
      return;
    if (this.adliyeliMi) {
      if (!this.ilamSorgulari.adliyeler.length)
        await this.adliyelerLoad();
      const adliyeVar = this.ilamSorgulari.adliyeler.some((item: any) => item.orgKodu == this.ilamSorgulari.adliye);
      if (adliyeVar && this.ilamSorgulari.adliye && this.ilamSorgulari.yargiBirimi)
        await this.loadIlamAdliyedekiTumMahkemeler();
    } else if (this.sorgulanabilirMi) {
      await this.loadIlamIldekiIdariBirimler();
    }
  }

  private mahkemeSeciminiTemizle() {
    this.ilamSorgulari.mahkeme = null;
    this.localValue.birimId = null;
    this.localValue.birimAdi = "";
  }

  async onIlamYargiBirimiChange(value: number | string) {
    this.ilamSorgulari.yargiBirimi = value;
    this.localValue.ilamBilgileri = {...this.localValue.ilamBilgileri, yargiBirimi: value};
    this.mahkemeSeciminiTemizle();
    this.sorguSonucunuGecersizKil();
    this.input();
    await this.mahkemeleriYukle(this.ilamSorgulari.il);
  }

  async onIlamAdliyeChange(value: number | string) {
    this.ilamSorgulari.adliye = value;
    this.localValue.adliyeId = value;
    this.mahkemeSeciminiTemizle();
    this.sorguSonucunuGecersizKil();
    this.input();
    if (this.ilamSorgulari.yargiBirimi)
      await this.loadIlamAdliyedekiTumMahkemeler();
  }

  /** Kullanıcı ili değiştirdiğinde mahkeme seçimi geçersizleşir; programatik yükleme için mahkemeleriYukle kullanılır. */
  async onIlamIlChange(value: any) {
    this.ilamSorgulari.il = value;
    // Seçim ilamın üzerinde saklanır; aksi halde diyalog kapanınca takibin iline geri dönüyordu.
    this.localValue.il = value;
    this.mahkemeSeciminiTemizle();
    this.sorguSonucunuGecersizKil();
    this.input();
    if (this.adliyeliMi)
      await this.adliyelerLoad();
    await this.mahkemeleriYukle(value);
  }

  onIlamMahkemeChange(value: any) {
    this.ilamSorgulari.mahkeme = value;
    this.localValue.birimId = value;
    const mahkeme = this.ilamSorgulari.mahkemeler.find((mahkeme: any) => mahkeme.birimId == value);
    this.localValue.birimAdi = mahkeme ? mahkeme.birimAdi : "";
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  onIlamDosyaYilChange(value: any) {
    this.ilamSorgulari.dosyaYil = value;
    this.localValue.dosyaYil = value;
    this.localValue.dosyaNo = this.localValue.dosyaYil + '/' + this.localValue.dosyaSira;
    this.localValue.ilamBilgileri = {...this.localValue.ilamBilgileri, dosyaYil: value};
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  onIlamDosyaSiraNoChange(value: any) {
    this.ilamSorgulari.dosyaSiraNo = value;
    this.localValue.dosyaSira = value;
    this.localValue.dosyaNo = this.localValue.dosyaYil + '/' + this.localValue.dosyaSira;
    this.localValue.ilamBilgileri = {...this.localValue.ilamBilgileri, dosyaSira: value};
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  onIlamKararYilChange(value: any) {
    this.ilamSorgulari.kararYil = value;
    this.localValue.kararDosyaYil = value;
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  onIlamKararSiraNoChange(value: any) {
    this.ilamSorgulari.kararSiraNo = value;
    this.localValue.kararDosyaSira = value;
    this.sorguSonucunuGecersizKil();
    this.input();
  }

  onIlamYevmiyeYilChange(value: any) {
    this.ilamSorgulari.yevmiyeYil = value;
    this.localValue.yevmiyeYil = value;
    this.input();
  }

  onIlamYevmiyeSiraNoChange(value: any) {
    this.ilamSorgulari.yevmiyeSiraNo = value;
    this.localValue.yevmiyeSira = value;
    this.input();
  }

  onKurumAdiChange(value: string) {
    this.ilamSorgulari.ilamliKurumAdi = value;
    this.localValue.ilamliKurumAdi = value;
    this.input();
  }

  /**
   * Dates boş değeri null yayıyor; Ilam alanları boş metin sözleşmesini koruyor
   * (toUyapJson değeri doğrudan gönderiyor).
   */
  onIlamTarihiChange(value: string | null) {
    this.localValue.ilamTarihi = value || "";
    this.input();
  }

  async ilamBilgileriniKontrolEt() {
    this.ilamSorgulari.kontrolYukleniyor = true;
    this.ilamSorgulari.kontrolHataMesaji = "";

    try {
      const result = await this.uyapTakipAc.ilamSorgusuYap();

      if (result.success) {
        this.ilamSorgulari.eslesmeDurumu = true;
        this.ilamSorgulari.kontrolHataMesaji = "";
      } else {
        this.ilamSorgulari.eslesmeDurumu = false;
        this.ilamSorgulari.kontrolHataMesaji = result.message || "İlam sorgusu başarısız oldu.";
      }
    } catch (error: any) {
      this.ilamSorgulari.eslesmeDurumu = false;
      this.ilamSorgulari.kontrolHataMesaji = error?.message || "İşlem sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.";
    } finally {
      this.ilamSorgulari.kontrolYukleniyor = false;
    }
  }
}
